'use client'

import { CookieNameEnum } from "@/src/constants/cookie-names"
import { runMiddleware } from "@/src/functions/gereric"
import { getCookie } from "cookies-next"
import { createContext, ReactNode, useContext, useEffect, useState } from "react"

interface AppAccessTokenContextType {
  appAccessToken?: string
}

const AppAccessTokenContext = createContext<AppAccessTokenContextType | undefined>(undefined)

export const AppAccessTokenProvider = ({ children }: { children: ReactNode }) => {
  const [appAccessToken, setAppAccessToken] = useState<string>()
  const [expTime, setExpTime] = useState<number>()

  const refreshToken = async () => {
    try {
      const response = await runMiddleware()

      if (response.ok) {
        const newToken = getCookie(CookieNameEnum.AppAccessToken) as string | undefined
        const newTime = getCookie(CookieNameEnum.AppAccessTokenExpiration) as string | undefined

        if (newToken && newTime) {
          setAppAccessToken(newToken)
          setExpTime(getExpTime(newTime))
        }
      }
    }
    catch (error) {
      console.apm('Erro ao atualizar token: ' + error)
    }
  }

  const getExpTime = (time: string) => {
    const expirationTimeMs = Number.parseInt(time) * 1000
    return expirationTimeMs
  }

  useEffect(() => {
    if (!expTime) return

    const expirationInterval = setInterval(refreshToken, expTime)

    return () => {
      clearInterval(expirationInterval)
    }
  }, [expTime])

  useEffect(() => {
    const appToken = getCookie(CookieNameEnum.AppAccessToken) as string | undefined
    const expires = getCookie(CookieNameEnum.AppAccessTokenExpiration) as string | undefined

    if (appToken && expires) {
      setAppAccessToken(appToken)
      setExpTime(getExpTime(expires))
    }
  }, [])

  return (
    <AppAccessTokenContext.Provider value={{ appAccessToken }}>
      {children}
    </AppAccessTokenContext.Provider>
  )
}

export const useAppAccessToken = (): AppAccessTokenContextType => {
  const context = useContext(AppAccessTokenContext)

  if (!context)
    throw new Error('O contexto de AppAccessToken deve estar dentro do AppAccessTokenProvider.')

  return context
}